<!--急救设备（无人车，无人机） 展示-->
<template>
  <div
    v-if="showContent"
    id="printPatientInfo"
  >
    <basicInfo id="basicInfo"/>
    <smart-status/>
    <situation id="situation"/>
    <drug id="drug"/>
    <hospital-emergency id="operation"/>
  </div>
</template>

<script>
import BasicInfo from "@/components/patientsSmart/BasicInfo.vue";
import Situation from "@/components/patientsSmart/Situation.vue";
import Drug from "@/components/patientsSmart/Drug.vue";
import HospitalEmergency from "@/components/patientsSmart/HospitalEmergency.vue";
import SmartStatus from "@components/patientsSmart/SmartStatus";
import { getPatient } from "@/api/hospitalList";
import { showWindowMessage } from "@utils/notification";
import "@/assets/css/patients.scss";

export default {
  name: "ShowPatient",
  components: {
    BasicInfo,
    SmartStatus,
    Situation,
    Drug,
    HospitalEmergency
  },
  data() {
    return {
      showContent: false,
      isShowPatient: false, // 是否属于查看
    };
  },
  mounted() {
    const all = this.$route.path.split("/");
    this.isShowPatient = all[1] === "showPatientSmart";
    this.getPatientInfo();
  },
  methods: {
    async getPatientInfo() {
      try {
        const patientID = this.$route.params.id;
        const patient = await getPatient(patientID);
        patient.pageInfo = {
          isWriteMore: this.isWriteMore,
          isAddPatient: this.isAddPatient,
          isShowPatient: this.isShowPatient,
        };
        this.$store.commit("updateShowOrEditPatientInfo", patient);
        this.showContent = true;
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
</style>
